module.exports = __webpack_public_path__ + "img/contaazul-icon.9d505373.png";